import { links } from '../content/site.js';

const connectCards = [
  {
    id: 'notion',
    url: links.notion,
    icon: 'notion',
    titleKey: 'connect.cards.notion.title',
    bodyKey:  'connect.cards.notion.body',
    linkKey:  'connect.cards.notion.link',
  },
  {
    id: 'linkedin',
    url: links.linkedin,
    icon: 'linkedin',
    titleKey: 'connect.cards.linkedin.title',
    bodyKey:  'connect.cards.linkedin.body',
    linkKey:  'connect.cards.linkedin.link',
  },
  {
    id: 'github',
    url: links.github,
    icon: 'github',
    titleKey: 'connect.cards.github.title',
    bodyKey:  'connect.cards.github.body',
    linkKey:  'connect.cards.github.link',
  },
  {
    id: 'blog',
    url: links.blog,
    icon: 'rss',
    titleKey: 'connect.cards.blog.title',
    bodyKey:  'connect.cards.blog.body',
    linkKey:  'connect.cards.blog.link',
  },
];

export default connectCards;
